var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-bar",class:_vm.loading ? 'bg-light-grey' : 'bg-charcoal'},[(!_vm.loading)?_c('div',[_c('BasicFilterForm',{staticClass:"f1",attrs:{"post-type":_vm.postType}})],1):_c('MoonSpinner',{attrs:{"loading":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }